module.exports = __webpack_public_path__ + "assets/img/chair.a47ecf2c.png";